<template>
    <div ref="action_toolbar" class="section-action-button-container exception">

        <!--

         WARNING: Due to highlighting for notes, all added elements must have .exception class
         @see this.findIndex()

         TODO: each of action buttons need to have unique ID

        -->

        <div class="mt-2 section-action-buttons disable-selection no-print" :id="`section-action-buttons-${sectionId}`"
             v-show="visible">

            <v-btn icon small rounded class="mr-2" @click="copyTextClicked">
                <v-icon class="trigger-copy-action text--secondary" aria-label="Copy text">
                    mdi-content-copy
                </v-icon>
            </v-btn>

            <v-btn icon small rounded class="mr-2" @click="bookmarkClicked">
                <v-icon class="trigger-bookmark-action text--secondary"
                        aria-label="Add note or bookmark">
                    mdi-bookmark-plus-outline
                </v-icon>
            </v-btn>

            <v-btn icon small rounded class="mr-2" @click="printClicked">
                <v-icon class="trigger-print-action text--secondary" aria-label="Print">
                    mdi-printer-outline
                </v-icon>
            </v-btn>

            <v-btn icon small rounded @click="copyLinkClicked">
                <v-icon class="trigger-share-action text--secondary" aria-label="Copy link">
                    mdi-link
                </v-icon>
            </v-btn>

        </div>

        <!-- Mobile Menu Trigger -->
        <div class="mt-2 section-action-button-mobile disable-selection">
            <v-btn aria-label="Section Action Menu" @click="mobileActionFiredIcon" icon text rounded class="float-right section-action-menu-trigger-mobile">

                <v-icon class="notranslate" aria-hidden="true">
                    mdi-dots-vertical
                </v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import {DomUtils} from "../../util/DomUtils";

export default {
    emits: ['copy', 'bookmark', 'print', 'share', 'fireMobileActions'],
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: true
        },
        /**
         * @type {ContentRestrictions}
         */
        contentRestrictions: {
            type: Object,
            required: true,
            default: {}
        },
        sectionId:{
            required: true,
            type: Number
        },
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        copyTextClicked() {

            if (this.contentRestrictions.canCopy) {
                this.$emit('copy');
            } else {
                EventBus.fire('subscription-prompt');
            }
        },
        bookmarkClicked() {

            if (this.contentRestrictions.canBookmark) {
                this.$emit('bookmark');
            } else {
                EventBus.fire('subscription-prompt');
            }
        },
        printClicked() {

            if (this.contentRestrictions.canPrint) {
                this.$emit('print');
            } else {
                EventBus.fire('subscription-prompt');
            }
        },
        copyLinkClicked() {

            if (this.contentRestrictions.canShare) {
                this.$emit('share');
            }
        },
        mobileActionFiredIcon(){
            this.$emit('fireMobileActions');
        },
        bindToolBarActions(){
            const toolbarElements = this.$refs.action_toolbar;
            const lockIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="16" height="16">
                        <title>lock-outline</title>
                        <path d="M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" />
                    </svg>`;

            const tooltipSettings = {
                trigger: 'mouseenter focus',
                allowHTML: true,
                delay: 0,
                duration: 0,
                arrow: false,
                animation: false,
            };

            const actionButtons = toolbarElements.querySelectorAll('.trigger-copy-action, .trigger-bookmark-action, .trigger-print-action, .trigger-share-action');
            actionButtons.forEach((el) => {

                let titleText = el.getAttribute('aria-label');

                // which type of action it is?
                const isCopy = el.classList.contains('trigger-copy-action');
                const isBookmark = el.classList.contains('trigger-bookmark-action');
                const isPrint = el.classList.contains('trigger-print-action');
                const isShareLink = el.classList.contains('trigger-share-action');

                if (isCopy && !this.contentRestrictions.canCopy) {
                    titleText = `${lockIconSvg} ${titleText}`;
                }

                if (isBookmark && !this.contentRestrictions.canBookmark) {
                    titleText = `${lockIconSvg} ${titleText}`;
                }

                if (isPrint && !this.contentRestrictions.canPrint) {
                    titleText = `${lockIconSvg} ${titleText}`;
                }

                if (isShareLink && !this.contentRestrictions.canShare) {
                    titleText = `${lockIconSvg} ${titleText}`;
                }

                DomUtils.addTooltip(el, titleText, tooltipSettings);

            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.bindToolBarActions();
        })

    },
}
</script>
